var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 15,
    viewBox: "0 0 302 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.292911 6.79289C-0.0976131 7.18342 -0.0976131 7.81658 0.292911 8.20711L6.65687 14.5711C7.0474 14.9616 7.68056 14.9616 8.07109 14.5711C8.46161 14.1805 8.46161 13.5474 8.07109 13.1569L2.41423 7.5L8.07109 1.84315C8.46161 1.45262 8.46161 0.819457 8.07109 0.428933C7.68056 0.0384083 7.0474 0.0384083 6.65687 0.428933L0.292911 6.79289ZM301.707 8.20711C302.098 7.81658 302.098 7.18342 301.707 6.79289L295.343 0.428933C294.953 0.0384083 294.32 0.0384083 293.929 0.428933C293.538 0.819457 293.538 1.45262 293.929 1.84315L299.586 7.5L293.929 13.1569C293.538 13.5474 293.538 14.1805 293.929 14.5711C294.32 14.9616 294.953 14.9616 295.343 14.5711L301.707 8.20711ZM1.00002 8.5H301V6.5H1.00002V8.5Z",
    fill: "#386ED6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.4bd11b09854087ab41cf3420e4b55da6.svg";
export { ForwardRef as ReactComponent };